module.exports = __webpack_public_path__ + "media/identify/icon_first-8350b586.svg";